import { Loader2 } from 'lucide-react';
import { SpinnerContainer } from './styled';
import { SpinnerProps } from './types';

const Spinner = ({ size = 24, className, ...props }: SpinnerProps) => {
    return (
        <SpinnerContainer className={className} {...props}>
            <Loader2 size={size} className="animate-spin" />
        </SpinnerContainer>
    );
};

export default Spinner;
